import { makePublicUrl } from 'app/utils/publicUrl'
import { Marking } from 'components/Mark'
import { SubscriptionPlan } from 'features/home/components/HomeSubscription/types'
import theme from 'theme_'

export const HOME_REDUCER_NAME = 'home'
export const DELETE_DOMAIN_CONFIG_REDUCER_NAME = 'deleteDomainConfig'
export const DEPLOY_DOMAIN_CONFIG_REDUCER_NAME = 'deployDomainConfig'
export const HOME_ACTIVE_CONFIG_REDUCER_NAME = 'activeConfig'
export const HOME_ACTIVE_CONFIG_ENERGY_REDUCER_NAME = 'activeEnergyConfig'
export const HOME_ACTIVE_CONFIG_ENERGY_DATA_REDUCER_NAME = 'activeEnergyDataConfig'
export const HOME_AVAILABLE_SOFTWARE_REDUCER_NAME = 'availableSoftware'
export const HOME_JOB_REDUCER_NAME = 'homeJob'
export const HOME_CLOUD_SOFTWARE_HISTORY_REDUCER_NAME = 'cloudSoftwareHistory'
export const HOME_SOFTWARE_REDUCER_NAME = 'homeSoftware'
export const HOME_SOFTWARE_HISTORY_REDUCER_NAME = 'softwareHistory'
export const HOME_SOFTWARE_UPDATE_INSTALL_REDUCER_NAME = 'softwareUpdateInstall'
export const SELECTED_HOME_REDUCER_NAME = 'selectedHome'
export const INVITE_HOME_USER_REDUCER_NAME = 'inviteHomeUser'
export const HOME_AVAILABLE_LICENSES_LIST_REDUCER_NAME = 'availableLicensesList'
export const HOME_APPLY_LICENSE_REDUCER_NAME = 'homeApplyLicense'
export const SUBSCRIPTIONS_LIST_REDUCER_NAME = 'subscriptionsList'
export const SUBSCRIPTIONS_CREDIT_REDUCER_NAME = 'subscriptionsCreditList'
export const SUBSCRIPTION_HOME_PRICE = 'homeSubscriptionPrice'
export const SUBSCRIPTION_PRICES = 'subscriptionPrices'
export const SUBSCRIPTION_PERIOD_END = 'subscriptionPeriodEnd'
export const SUBSCRIPTIONS_HISTORY_REDUCER_NAME = 'subscriptionsHistory'
export const SELECTED_SUBSCRIPTION_PLAN_REDUCER_NAME =
  'selectedSubscriptionPlan'
export const REQUEST_ACCESS_REDUCER_NAME = 'requestAccess'
export const PAYMENT_REDUCER_NAME = 'payment'
export const PURCHASE_REQUEST_REDUCER_NAME = 'purchase'
export const PREVIEW_REQUEST_REDUCER_NAME = 'preview'
export const DOWNGRADE_REQUEST_REDUCER_NAME = 'downgrade'
export const RENEW_SUBSCRIPTION_REDUCER_NAME = 'renewSubscription'
export const MIGRATE_SUBSCRIPTION_REDUCER_NAME = 'migrateSubscription'
export const HOME_CONFIG_REDUCER_NAME = 'homeConfig'
export const HOST_PASSWORD_CHANGE_REDUCER_NAME = 'hostPasswordChange'
export const HOST_PASSWORD_RESET_REDUCER_NAME = 'hostPasswordReset'
export const HOME_ENERGY_HISTORY_REDUCER_NAME = 'homeEnergyHistory'

export const NO_PLAN: SubscriptionPlan = {
  id: 'no-plan',
  type: 'none',
  nickname: '',
  price: 0,
  interval: 'day',
}

export const ESSENTIAL_PLAN_TO_MIGRATE: SubscriptionPlan = {
  id: 'essential-plan-to-migrate',
  type: 'essential-to-migrate',
  nickname: '',
  price: 0,
  interval: 'day',
}

export const ESSENTIAL_PLAN: SubscriptionPlan = {
  id: 'essential-plan',
  type: 'essential',
  nickname: '',
  price: 0,
  interval: 'year',
}

export const userIconUrl = makePublicUrl('images/userIcon.svg')
export const HOST_POLL_TIMEOUT = 15000

export const deviceStatuses = ['Connected', 'Warning', 'Errors', 'No Status']

export const statusColors: Record<string, string> = {
  0: theme.colors.successGreen,
  1: theme.colors.statusYellow,
  2: theme.colors.error,
  3: theme.colors.moreGrey,
}

export const statusMarkings: Record<string, Marking> = {
  0: Marking.Check,
  1: Marking.Warning,
  2: Marking.Error,
  3: Marking.None,
}
